import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className='cs_contact_widget'>
      <li>
        <a
          href='https://www.google.com/maps/search/?api=1&query=9354+Florida+Blvd,+Walker,+LA+70785'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='cs_accent_bg'>
            <Icon icon='ep:location' />
          </i>
          9354 Florida Blvd, Walker, LA 70785
        </a>
      </li>
      <li>
        <a href='tel:+12256650323'>
          <i className='cs_accent_bg'>
            <Icon icon='fluent:call-24-regular' />
          </i>
          OFFICE (225) 665-0323
        </a>
      </li>
      <li>
        <a href='tel:+18886005553'>
          {/* <i className='cs_accent_bg'>
            <Icon icon='fluent:call-24-regular' />
          </i> */}
          CELL (888) 600-5553
        </a>
      </li>
      <li>
        <a href='tel:+12256650319'>
          {/* <i className='cs_accent_bg'>
            <Icon icon='fluent:call-24-regular' />
          </i> */}
          FAX (225) 665-0319
        </a>
      </li>
      <li>
        <a
          href='mailto:Ricky@freedomprola.com'
        >
          <i className='cs_accent_bg'>
            <Icon icon='bi:envelope' />
          </i>
          Ricky@freedomprola.com
        </a>
      </li>
      <p className='text-sm mt-4 text-gray-700'>
        <strong>Hours:</strong> 8:00 AM – 5:00 PM, Monday – Thursday <br />
        8:00 AM – 12:00 PM, Friday <br />
        <em>Closed for lunch 12:00 – 1:00 PM</em>
      </p>
    </ul>
  );
}
